module.exports = __webpack_public_path__ + "static/media/app-store-connect-graphs-reduced.557841c8.png";